module.exports = __webpack_public_path__ + "static/mai-logo-abd3048a6cc6e3eb3c310c1a62885529.svg";